"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XhrPluginsHelpers = void 0;
const mobileConnector_1 = require("../../../mobileConnector");
class XhrPluginsHelpers {
    constructor(getMobileConnector) {
        this.getMobileConnector = getMobileConnector;
        this.name = this.constructor.name;
        this.invalidateCache = () => {
            (0, mobileConnector_1.isWebViewPlatform)() && this.getMobileConnector().invalidateCache();
        };
    }
}
exports.XhrPluginsHelpers = XhrPluginsHelpers;
//# sourceMappingURL=xhrPluginsHelpers.js.map